/**
 * Validates the stringified input value of the date range picker component. A valid input value is a stringified array of two date strings.
 * @param {string} value The stringified input value of the date range picker component.
 * @returns {boolean} Whether the input value is valid.
 */
export const validateDateRangePickerInput = (value) => {
  if (!value) return false; // if value is null or undefined or empty string return false
  const parsedValue = JSON.parse(value);
  if (!(Array.isArray(parsedValue) && parsedValue.length === 2)) {
    return false; // if value is not an array of length 2 return false
  }
  const [fromDateStr, toDateStr] = parsedValue;
  const isValidFromDate = !isNaN(Date.parse(fromDateStr));
  const isValidToDate = !isNaN(Date.parse(toDateStr));
  return isValidFromDate && isValidToDate; // return true if both dates are valid
};
